
import { computed, defineComponent, PropType } from 'vue'
import { useRouter } from 'vue-router/composables'

import { Breadcrumb } from '../types'
import UserInfo from './UserInfo.vue'

export default defineComponent({
  name: 'App',
  components: {
    UserInfo
  },
  props: {
    breadcrumbs: {
      type: Array as PropType<Array<Breadcrumb>>,
      default: []
    },
    navigateFunc: Function
  },
  setup() {
    const clientUrl = process.env.VUE_APP_CLIENT_URI || 'http://localhost:4200'
    const router = useRouter()

    const dashboardUrl = computed(() => {
      return clientUrl + '/dashboard?redirect=false'
    })

    function navigateToBreadcrumb(breadcrumb: Breadcrumb): void {
      router.push(`${breadcrumb.to}`)
    }

    return {
      dashboardUrl,
      navigateToBreadcrumb
    }
  }
})
